import React from "react"
import AboutCard from "../about/AboutCard"
import Hblog from "./Hblog"
import HAbout from "./HAbout"
import Hero from "./hero/Hero"
import Hprice from "./Hprice"
import Testimonial from "./testimonial/Testimonial"

const Home = () => {
  return (
    <>
      <Hero /> 
      <HAbout />
      <AboutCard />
      <Testimonial />
      <Hblog />
      {/* <Hprice /> */}
    </>
  )
}

export default Home
